export default __webpack_public_path__ + "locales/lo-LA/InfoPanel.json?hash=0a73edaff919ff1dd9791c9702f4e5fa";